import script from "./SecNote.vue?vue&type=script&setup=true&lang=js"
export * from "./SecNote.vue?vue&type=script&setup=true&lang=js"

import "./SecNote.vue?vue&type=style&index=0&id=0e1a1d2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e1a1d2a"]])

export default __exports__